import Vue from 'vue'
import vuetifyNsuk from "../plugins/vuetify";
import AppNsuk from "./Verification.vue";
import router from './routes/index';
import store from "./store";
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import axios from 'axios';
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import NotificationPlugin from '../plugins/notify';
import urlUtil from "@/utils/urlUtil";


// set default api
// set default api
axios.defaults.baseURL = urlUtil.getBaseUrl();


Vue.config.productionTip = false;
Vue.use(NotificationPlugin)
Vue.use(VueToast);

new Vue({
    vuetify: vuetifyNsuk,
    router,
    store,
    render: (h) => h(AppNsuk),
}).$mount("#app");
